import { Layout } from 'layout/layout'
import { Header } from 'layout/header'
import { PrivacyPolicy } from 'app/components/pages/privacy'

const Privacy = () => {
  return (
    <Layout>
      <Header redirect />
      <PrivacyPolicy />
    </Layout>
  )
}

export default Privacy
